import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react'
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextEditor from '../../../../../../../shared-components/TextEditor'
import InitialLetters from '../../../../../../../utils/InitialLetters'
import SuperSearchList from '../../../../../../shared/SuperSearch/SuperSearchList'
import profileicon from "../../../../../../../assets/img/icon-profile.svg"
import { enumUtil } from '../../../../../../../utils/Enum';
import isNull from '../../../../../../../utils/NullChecking';
import { useSelector } from 'react-redux';
// import EncounterDetails from './EncounterDetails/EncounterDetails';
import { format } from 'date-fns';
import { ServerRequestProtected } from '../../../../../../../utils/ServerDataRequest';
import Loader from '../../../../../../shared/Loader/Loader';
import SOAP from './SOAP/SOAP';
import ReloadGridAction from '../../../../../../../actions/ReloadGridAction';
import { useDispatch } from 'react-redux';
import FormValidator from '../../../../../../../utils/FormValidator';
import DropdownValueHandler from '../../../../../../shared/SuperSearch/DropdownValueHandler';
import NotificationHandler from '../../../../../../../utils/NotificationHandler';
// import { OpenNewEncounterTabAction } from '../../../../../../../actions/BillingActions';
import SectionScrollNavigator from './SOAP/Components/SectionScrollNavigator';
import OtherNote from './OtherNote/OtherNote';
import SOAPwithDetails from './SOAP/SOAPwithDetails';
import OtherNotewithDetails from './OtherNote/OtherNotewithDetails';
import GIRPNotewithDetails from './GIRPNote/GIRPNotewithDetails';
import BIRPNotewithDetails from './BIRPNote/BIRPNotewithDetails';
import Modal from 'react-bootstrap/Modal';
import ModalHeader from '../../../../../../Setup/Shared/ModalHeader';
import DAPPNotewithDetails from './DAPPNote/DAPPNotewithDetails';
import DAPNotewithDetails from './DAPNote/DAPNotewithDetails';
import TherapyNotewithDetails from './TherapyNote/TherapyNotewithDetails';
import MassageNotewithDetails from './MassageNote/MassageNotewithDetails';
import PhysicalNotewithDetails from './PhysicalNote/PhysicalNotewithDetails';
import DAPNote from './DAPNote/DAPNote';
import CustomNotewithDetails from './CustomNote/CustomNotewithDetails';
import GroupCustomNotewithDetails from './GroupCustomNote/GroupCustomNotewithDetails';
// import EncounterPreview from './SOAP/Components/EncounterPreview';

const TemplateView = (props) => {
    let dispatch = useDispatch();
    let PatientIDR =
        useSelector(state =>
            state.Open_Patient_Tab?.find((pt) => pt.active === true)?.data?.id);

    let EncounterType =
        useSelector(state =>
            state.Open_Patient_Tab?.find((pt) => pt.active === true)
                ?.Open_Encounter_Tab?.find((pt) => pt.active === true)
                ?.data?.type);

    let EncounterIDR =
        useSelector(state =>
            state.Open_Patient_Tab?.find((pt) => pt.active === true)
                ?.Open_Encounter_Tab?.find((pt) => pt.active === true)
                ?.data?.id
        );
    let EncounterData =
        useSelector(state =>
            state.Open_Patient_Tab?.find((pt) => pt.active === true)
                ?.Open_Encounter_Tab?.find((pt) => pt.active === true)
                ?.data?.id
        );

    let EncounterDate =
        useSelector(state =>
            state.Open_Patient_Tab?.find((pt) => pt.active === true)
                ?.Open_Encounter_Tab?.find((pt) => pt.active === true)
                ?.data?.name);
    const [encounterType, setEncounterType] = useState('');
    const [encounterID, setEncounterID] = useState('');
    const [encounterDate, setEncounterDate] = useState('');
    const [encounterData, setEncounterData] = useState('');

    const [patientID, setPatientID] = useState('')
    const API_URL_GENERAL = enumUtil.controller.General
    const [isLoading, setIsLoading] = useState(false);
    const [isNoteTypeChangeConfirmation, setIsNoteTypeChangeConfirmation] = useState(false);

    useEffect(() => {
        setEncounterType(EncounterType);
        setEncounterID(EncounterIDR);
        setPatientID(PatientIDR);
        setEncounterDate(EncounterDate)
        setEncounterData(EncounterData)
    }, [])

    const handleUpdateNoteType = (newType) => {
        let newObj = {
            key: 2,
            name: "Encounter",
            active: true,
            data: {
                id: encounterID,
                name: encounterDate,
                type: newType,
                time: new Date(),
            },
        };
        dispatch({
            type: 'Open_New_Encounter_Tab',
            payload: {
                patientId: patientID,
                encounterId: encounterID,
                newObj: newObj
            }
        });
        dispatch(ReloadGridAction({ EncounterSearch: true }));
    }

    const Heading = () => {
        return <p className='heading Rejected_clr'>Change Note Type?</p>;
    };

    const confirmationMsg = () => {
        return new Promise((resolve, reject) => {
            const handleConfirmation = (userConfirmed) => {
                if (userConfirmed) {
                    resolve(userConfirmed);
                } else { reject(userConfirmed); }
                setIsNoteTypeChangeConfirmation(<></>);
            };
            setIsNoteTypeChangeConfirmation(
                <Modal show={true} onHide={() => handleConfirmation(false)} backdrop="static" keyboard={false} centered dialogClassName="app-modal hk-modal-v1 ar_select_opt  za-update-subscriber-id za-discard-changes za-exit-group ">
                    <ModalHeader HeaderName={Heading} DeletePopup={""} isClosed={() => handleConfirmation(false)} key={6331} Name={'ChanegNoteType'} />
                    <Modal.Body>
                        <div className='ar-alert d-flex mb-12'>
                            <i className='icon-Vector13 mt-1'></i>
                            <div>
                                <p className='text ms-1'>Changing the note type will remove all the data you’ve entered. Do you want to continue?</p>
                            </div>
                        </div>
                    </Modal.Body>

                    <div className="modal_footer za_br_light br-top-1 pt-2 ">
                        <div className='za-button text-end d-flex justify-content-end gap-2'>
                            <button className='btn btn-outline fs-12 px-10 rounded drk_clr' onClick={() => handleConfirmation(false)}>Cancel</button>
                            <button className='btn btn-danger fs-12 px-10 rounded' onClick={() => handleConfirmation(true)}>Continue</button>
                        </div>
                    </div>
                </Modal>)
        })
    }

    const handleSave = (newValue) => {
        setIsLoading(true)
        ServerRequestProtected(API_URL_GENERAL + "/SaveSingleRecord", 'post', {
            "TableName": enumUtil.enumAPITableName.Encounter,
            "ID": encounterID,
            "Data": {
                "NoteType": newValue,
            },
        }).then((response) => {
            setIsLoading(false)
            handleUpdateNoteType(newValue);
            setEncounterType(newValue)
            NotificationHandler("Note Type Changed", enumUtil.enumtoaster.success);
        }).catch((error) => {
            setIsLoading(false)
            NotificationHandler("Note Type Change Failed!", enumUtil.enumtoaster.error);
        })
    }

    const handleNoteTypeChange = async (oldValue, newValue, getSaveData, setSearchParam, setSearchValue, newDisplay) => {

        if (!isNull(oldValue) && oldValue !== newValue) {
            const userConfirmed = await confirmationMsg();
            if (!userConfirmed) return false;

            // setSearchParam((prev) => ({ ...prev,  RemoveEncounterData: "true",  NoteType: newValue }));
            setSearchParam((prev) => ({ ...prev, RemoveEncounterData: "true" }));
            setSearchValue(prev => ({ ...prev, NoteType: newDisplay + "" }));

            if (typeof getSaveData === "function") {
                await handleSave(newValue);
                // setIsNoteChangedTo(newValue);
            }
            return true;
        }
        setSearchParam((prev) => ({ ...prev, NoteType: newValue }));
        setSearchValue(prev => ({ ...prev, NoteType: newDisplay + "" }));

        return true;
    };

    let noteComponent = null;
    if (encounterData?.groupEncounter?.isGroupEncounter === 'true') {
        noteComponent = (
            <GroupCustomNotewithDetails
                key={encounterType}
                {...props}
                handleNoteTypeChange={handleNoteTypeChange}
                encounterID={encounterID}
                encounterType={encounterType}
                encounterDataRedux={encounterData}
            />
        );
    } else {
        switch (encounterType) {
            case "SOAP":
                noteComponent = <SOAPwithDetails {...props} handleNoteTypeChange={handleNoteTypeChange} encounterID={encounterID} encounterType={encounterType} />;
                break;

            case "Other":
                noteComponent = <OtherNotewithDetails {...props} handleNoteTypeChange={handleNoteTypeChange} encounterID={encounterID} encounterType={encounterType} />;
                break;

            case "GIRP":
                noteComponent = <GIRPNotewithDetails {...props} handleNoteTypeChange={handleNoteTypeChange} encounterID={encounterID} encounterType={encounterType} />;
                break;

            case "BIRP":
                noteComponent = <BIRPNotewithDetails {...props} handleNoteTypeChange={handleNoteTypeChange} encounterID={encounterID} encounterType={encounterType} />;
                break;

            case "DAPP":
                noteComponent = <DAPPNotewithDetails {...props} handleNoteTypeChange={handleNoteTypeChange} encounterID={encounterID} encounterType={encounterType} />;
                break;

            case "DAP":
                noteComponent = <DAPNotewithDetails {...props} handleNoteTypeChange={handleNoteTypeChange} encounterID={encounterID} encounterType={encounterType} />;
                break;

            case "Massage":
                noteComponent = <MassageNotewithDetails {...props} handleNoteTypeChange={handleNoteTypeChange} encounterID={encounterID} encounterType={encounterType} />;
                break;

            case "Physical":
                noteComponent = <PhysicalNotewithDetails {...props} handleNoteTypeChange={handleNoteTypeChange} encounterID={encounterID} encounterType={encounterType} />;
                break;

            case "Therapy":
                noteComponent = <TherapyNotewithDetails {...props} handleNoteTypeChange={handleNoteTypeChange} encounterID={encounterID} encounterType={encounterType} />;
                break;
            default:
                noteComponent = <CustomNotewithDetails key={encounterType} {...props} handleNoteTypeChange={handleNoteTypeChange} encounterID={encounterID} encounterType={encounterType} />;
        }
    }
    console.log("searchParam NoteType encounterType", encounterType)
    return (<>
        {isNoteTypeChangeConfirmation}
        {isLoading ? <Loader /> : null}

        {/* ///// (Need to create Save for CopyEncounter in EncounterSearch , EncounterMenuSearch), Past Encounter, Bulk Print Setting Modal, Encounter Wrapper for Claim & Encounter Wrapper in Encounter Menu for every new Note Type///// */}
        {noteComponent}
    </>
    )
}

export default TemplateView
